module.exports = __webpack_public_path__ + "assets/img/banner1-text1@3x.fa359bf8.jpeg";